export default __webpack_public_path__ + "static/media/op.1d5e4e4a.png";